import useActivityAcknowledgementContext from '/druid/private/useContext';

export default function useLastReadActivityKey(): readonly [string] {
  return useActivityAcknowledgementContext().lastReadActivityKeyState;
}
